// extracted by mini-css-extract-plugin
export default {"forumsContainer":"Forums_forumsContainer__VgddC","pageTitle":"Forums_pageTitle__fcp7H","forumsCreate":"Forums_forumsCreate__uuTJq","forumsTable":"Forums_forumsTable__h8+n8"};